import {
  FeatureGateName,
  WebinarListSection,
  deserify,
} from '@geneo2-web/shared-ui';
import { WebinarListRole } from '@geneo2-web/services-clients';
import { useAppSelector } from '../../../reduxStore/reduxHooks';
import { useFeatureGate } from '../../../utils/customHooks';

export default function HomeWebinarList() {
  const webinarEnabled = useFeatureGate(FeatureGateName.webinarEnabled);
  const userInfo = deserify(useAppSelector((state) => state.auth.userInfo));
  const profileId = Number(userInfo?.studentProfileId ?? 0);
  const schoolId = Number(userInfo?.schoolDetails?.schoolId ?? 0);

  if (!webinarEnabled || !profileId || !schoolId) return null;

  return (
    <WebinarListSection
      title="Webinars"
      role={WebinarListRole.STUDENT}
      profileId={profileId}
      schoolId={schoolId}
      linkType="join"
      hideWhenEmpty
    />
  );
}
